import React from "react";
import './HeaderAll.css';
import HeaderAll01 from "../../img/MainMenu/MainMenu01.svg";
import CreditLogo from "../../img/MainMenu/logo-artyfact.png";
import HeaderAll02 from "../../img/MainMenu/MainMenu02.svg";
import HeaderAll03 from "../../img/MainMenu/MainMenu03.svg";
import russia from "../../img/MainMenu/russia.png";
import germany from "../../img/MainMenu/germany.png";
import unitedkingdom from "../../img/MainMenu/united-kingdom.png";
import china from "../../img/MainMenu/china.png";
import korea from "../../img/MainMenu/korea.png";
import france from "../../img/MainMenu/france.png";

import italy from "../../img/MainMenu/italy.png";
import japan from "../../img/MainMenu/japan.png";
import portugal from "../../img/MainMenu/portugal.png";
import spain from "../../img/MainMenu/spain.png";
import turkey from "../../img/MainMenu/turkey.png";
import vietnam from "../../img/MainMenu/vietnam.png";
import oae from "../../img/MainMenu/oae.png";

import downward from "../../img/MainMenu/downward-arrow.png";
import favicon from "../../img/MainMenu/favicon.png";
import XSVG from "../../img/X.svg";
import bamb_menu from "../../img/menu.png";
import { NavLink } from "react-router-dom"
import {ApolloConsumer, Mutation} from "react-apollo";
import Query from "react-apollo/Query";
import { createBrowserHistory } from 'history';
import {withAuth} from "../withAuth";
import {withRouter} from "react-router-dom";
import '../Elements/Buttons/ButtonRed/ButtonRed.css';
import ButtonGreen from "../Elements/Buttons/ButtonGreen/ButtonGreen";
import {CHANGE_PASSWORD, GET_USER_KYC} from "../../queries";
const history = createBrowserHistory();
const bcrypt = require('bcryptjs');
import { menuText } from "./menuLang";
import StatusKYC from "./KYCstatus";


const SignOutFunction = (client, history) => {
    setTimeout(() => window.open('https://artyfact.game/', '_top'), 1000);
    localStorage.setItem('token', '');
    // Удаляет стор Apollo
    
    client.resetStore();
    // history.push('/');
    // location.reload();
};


    function SignOut(props) {
        if (props.active === 'Active'){return (
            <ApolloConsumer>
                {client =>{
                    return(<div className="SignOut">
                        <div className="LogOutButton" onClick={() => SignOutFunction(client, history)}>{props.logout}</div>
                    </div>)
                }}
            </ApolloConsumer>
        )}
        else {return(<div className="SignOut">
            <div className="LogOutButtonNotActive">LOGOUT.</div>
        </div>)
                    }
        }
        //<div className="LogOutButton" onClick={() => SignOutFunction(client, history)}>{'LOGOUT ' + props.email}</div>

class HeaderAll extends React.Component {
    constructor(props){
        super(props);
        this.state = {

            openMenu : true,
            email: this.props.session.email,

            password : '',
            passwordConfirm : '',
            passwordOld : '',
            PasswordOld : '',
            hideNav : '',
            Password : '',
            passwordMessage: '',
            GlobalBlack: "StandartUnVisible",
            ChangePassword : "StandartUnVisible",
            ModalSupportShow: false,
            ModalFAQShow: false,
            Language : localStorage.getItem('language') ? localStorage.getItem('language') : 'en',
            showLangMenu: false
        };
        this.ChangeMenu = this.ChangeMenu.bind(this);
        this.ChangeElement = this.ChangeElement.bind(this);
        this.GlobalBlack = this.GlobalBlack.bind(this);
        this.ChangePassword = this.ChangePassword.bind(this);
        this.ChangePasswordElement = this.ChangePasswordElement.bind(this);
        this.ChangePasswordElement2 = this.ChangePasswordElement2.bind(this);
        this.ChangePasswordElementOld = this.ChangePasswordElementOld.bind(this);
        this.changeLangButton = this.changeLangButton.bind(this);
    };

    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
    }

    resize() {
        this.setState({hideNav: window.innerWidth <= 800});
    }

    ChangeElement = event => {
        const {name, value} = event.target;
        this.setState({[name] : value});
        console.log(this.state);
    };

    changeLanguage = (event, lang) => {
        localStorage.setItem('language',lang);
        console.log(localStorage.getItem('language'));
        this.setState({Language : lang});
        location.reload();
    }

    ChangePasswordElement = event => {
        const {name, value} = event.target;
        let salt = bcrypt.genSaltSync(10);
        let newvalue = bcrypt.hashSync(value, salt);
        this.setState({[name] : value, Password: newvalue});
        if (value == this.state.passwordConfirm) {
            this.setState({passwordMessage : "passwords match"});
        } else {
            this.setState({passwordMessage : "passwords don't match"});
        }
    };

    ChangePasswordElement2 = event => {
        const {name, value} = event.target;
        let salt = bcrypt.genSaltSync(10);
        let newvalue = bcrypt.hashSync(value, salt);
        this.setState({[name] : value, Password: newvalue});
        if (this.state.password == value) {
            this.setState({passwordMessage : "passwords match"});
        } else {
            this.setState({passwordMessage : "passwords don't match"});
        }
    };

    ChangePasswordElementOld = event => {
        const {name, value} = event.target;
        // let salt = bcrypt.genSaltSync(10);
        // let newvalue = bcrypt.hashSync(value, salt);
        this.setState({[name] : value, PasswordOld: value});
    };

    ChangePassword(e) {
        e.preventDefault();
        this.setState({ChangePassword : "StandartVisible", GlobalBlack: "StandartVisible"});
    };

    GlobalBlack(e) {
        e.preventDefault();
        this.setState({ GlobalBlack: "StandartUnVisible",
            ChangePassword : "StandartUnVisible"});
    };

    ChangeMenu = () => {
        this.setState({openMenu: !this.state.openMenu,});
    };

    CloseModalSupport = event => {
        this.setState({ ModalSupportShow: false });
    }

    OpenModalSupport = event => {
        this.setState({ ModalSupportShow: true });
    }

    CloseModalFAQ = event => {
        this.setState({ ModalFAQShow: false });
    }

    OpenModalFAQ = event => {
        this.setState({ ModalFAQShow: true });
    }

    changeLangButton = event => {
        event.preventDefault();
        const showLang = this.state.showLangMenu;
        this.setState({ showLangMenu: !showLang });
    }

    changePasswordMutation = (event, changePassword) => {
        event.preventDefault();
        if (this.state.password == this.state.passwordConfirm) {
            this.setState({passwordMessage : menuText.match_pass[this.state.Language]} );
            changePassword().then(
                ({data}) => {
                    this.setState({
                        GlobalBlack: "StandartUnVisible",
                        ChangePassword: "StandartUnVisible"
                    });
                },
                error => {
                    let ErrorString = '' + error;
                    alert(ErrorString.replace('Error: GraphQL error:', ''));
                } 
            )
        } else {
            this.setState({passwordMessage : "passwords don't match"});
        }
        

    };

    render() {
        const details = document.querySelector('details');
        let AuthTraderName = "noAuth";
        let LogoutName = '';
        let ActiveLogout = '';
       if ( this.props.session) {
           AuthTraderName = this.props.session.Name + ' ' + this.props.session.Surname;
           LogoutName = this.props.session.Name;
           ActiveLogout = 'Active';
       }
        
    if (this.state.openMenu && this.state.hideNav) {
        return (
            <div className="HeaderAllOut">
                <div className="HeaderAllUp">
                    <div className="HeaderAllTopTitleUp">
                        <div className="HeaderAllTopPropsLang">
                            <div className="HeaderAllTopPropsLangImg"><img src={CreditLogo}/></div>
                            <div className="HeaderAllTopPropsLangText">Launchpad</div>
                        </div>
                        <details class="dropdown">
                            <summary role="button">
                                <a class="button">
                                    {this.state.Language == 'en' &&
                                        <img width="20px" src={unitedkingdom}/>
                                    }
                                    {this.state.Language == 'de' &&
                                        <img width="20px" src={germany}/>
                                    }
                                    {this.state.Language == 'fr' &&
                                        <img width="20px" src={france}/>
                                    }
                                    {this.state.Language == 'ko' &&
                                        <img width="20px" src={korea}/>
                                    }
                                    {this.state.Language == 'ch' &&
                                        <img width="20px" src={china}/>
                                    }
                                    {this.state.Language == 'ru' &&
                                        <img width="20px" src={russia}/>
                                    }
                                    {this.state.Language == 'it' &&
                                        <img width="20px" src={italy}/>
                                    }
                                    {this.state.Language == 'jap' &&
                                        <img width="20px" src={japan}/>
                                    }
                                    {this.state.Language == 'port' &&
                                        <img width="20px" src={portugal}/>
                                    }
                                    {this.state.Language == 'turk' &&
                                        <img width="20px" src={turkey}/>
                                    }
                                    {this.state.Language == 'viet' &&
                                        <img width="20px" src={vietnam}/>
                                    }
                                    {this.state.Language == 'spa' &&
                                        <img width="20px" src={spain}/>
                                    }
                                    {this.state.Language == 'arab' &&
                                        <img width="20px" src={oae}/>
                                    }
                                    <img className="ml5px" width="15px" src={downward}/>
                                </a>
                            </summary>
                            <ul>
                                {this.state.Language != 'en' &&
                                <li><img width="24px" onClick={event => this.changeLanguage(event, 'en')} style={{ cursor: 'pointer' }} src={unitedkingdom}/></li>}
                                {this.state.Language != 'de' &&
                                <li><img width="24px" onClick={event => this.changeLanguage(event, 'de')} style={{ cursor: 'pointer' }} src={germany}/></li>}
                                {this.state.Language != 'fr' &&
                                <li><img width="24px" onClick={event => this.changeLanguage(event, 'fr')} style={{ cursor: 'pointer' }} src={france}/></li>}
                                {this.state.Language != 'ko' &&
                                <li><img width="24px" onClick={event => this.changeLanguage(event, 'ko')} style={{ cursor: 'pointer' }} src={korea}/></li>}
                                {this.state.Language != 'ch' &&
                                <li><img width="24px" onClick={event => this.changeLanguage(event, 'ch')} style={{ cursor: 'pointer' }} src={china}/></li>}
                                {this.state.Language != 'ru' &&
                                <li><img width="24px" onClick={event => this.changeLanguage(event, 'ru')} style={{ cursor: 'pointer' }} src={russia}/></li>}
                                {this.state.Language != 'it' &&
                                <li><img width="24px" onClick={event => this.changeLanguage(event, 'it')} style={{ cursor: 'pointer' }} src={italy}/></li>}
                                {this.state.Language != 'jap' &&
                                <li><img width="24px" onClick={event => this.changeLanguage(event, 'jap')} style={{ cursor: 'pointer' }} src={japan}/></li>}
                                {this.state.Language != 'port' &&
                                <li><img width="24px" onClick={event => this.changeLanguage(event, 'port')} style={{ cursor: 'pointer' }} src={portugal}/></li>}
                                {this.state.Language != 'turk' &&
                                <li><img width="24px" onClick={event => this.changeLanguage(event, 'turk')} style={{ cursor: 'pointer' }} src={turkey}/></li>}
                                {this.state.Language != 'viet' &&
                                <li><img width="24px" onClick={event => this.changeLanguage(event, 'viet')} style={{ cursor: 'pointer' }} src={vietnam}/></li>}
                                {this.state.Language != 'spa' &&
                                <li><img width="24px" onClick={event => this.changeLanguage(event, 'spa')} style={{ cursor: 'pointer' }} src={spain}/></li>}
                                {this.state.Language != 'arab' &&
                                <li><img width="24px" onClick={event => this.changeLanguage(event, 'arab')} style={{ cursor: 'pointer' }} src={oae}/></li>}
                            </ul>
                        </details>
                        <img className="img-menu-mob" src={bamb_menu} onClick={this.ChangeMenu}/>
                    </div>
                </div>
            </div>
        )
    } else {
        return (
            <>
            <div className="HeaderAllOut">
                <div className={"StandartAllBlack " + this.state.GlobalBlack} onClick={this.GlobalBlack}/>

                <div className={"VerificationBlockOut ChangePasswordInputBlockOut " + this.state.ChangePassword}>
                    <div className="closeModal closeModal2" onClick={this.GlobalBlack}>×</div>
                    <div className="VerificationBlock ChangePasswordInputBlock">                        
                        <div className="VerificationBlockTitle">
                            {menuText.pass_text1[this.state.Language]}
                        </div>
                        <div className="ChangePasswordInputBlockIn" >
                            <input className="ChangePasswordInput" type="password" value={this.state.passwordOld ? this.state.passwordOld : ''} name="passwordOld" onChange={this.ChangePasswordElementOld} placeholder={menuText.old_pass[this.state.Language]}/>
                            <input className="ChangePasswordInput" type="password" value={this.state.password ? this.state.password : ''} name="password" onChange={this.ChangePasswordElement} placeholder={menuText.new_pass[this.state.Language]}/>
                            <input className="ChangePasswordInput" type="password" value={this.state.passwordConfirm ? this.state.passwordConfirm : ''} name="passwordConfirm" onChange={this.ChangePasswordElement2} placeholder={menuText.confirm_pass[this.state.Language]}/>
                        </div>
                        <div className="passwordMessage">{this.state.passwordMessage}</div>
                        <Mutation mutation={CHANGE_PASSWORD} variables={{ email:this.state.email, password : this.state.Password, passwordOld: this.state.PasswordOld}}>
                            {(changePassword,{data, loading, error}) => {
                                return(
                                    <div className="VerificationBlockButtons"  onClick={event => this.changePasswordMutation(event, changePassword)}>                                        
                                        <div className='ButtonRed' onClick={this.GlobalBlack}>{menuText.decline[this.state.Language]}</div>
                                        <ButtonGreen ssilka='#' classname='ButtonGreen' label={menuText.accept[this.state.Language]} />
                                    </div>
                                )}}
                        </Mutation>
                    </div>
                </div>

                <div className="HeaderAll">
                    <div className="HeaderAllTopTitle">
                        <div className="HeaderAllTopTitleText">{menuText.metaverse[this.state.Language]}</div>
                    </div>
                    <div className="HeaderAllTopProps">
                        <div className="HeaderAllTopPropsPassword" onClick={this.ChangePassword}>
                            <div className="HeaderAllTopPropsPasswordImg"><img src={HeaderAll02}/></div>
                            <div className="HeaderAllTopPropsPasswordText">{menuText.password[this.state.Language]}</div>
                        </div>
                        <img src={XSVG} className="hide-desk" width={35} onClick={this.ChangeMenu}/>
                        <details class="dropdown hidemob" open={this.state.showLangMenu ? true : false}>
                            <summary role="button" onClick={event => this.changeLangButton(event)}>
                                <a class="button">
                                    {this.state.Language == 'en' &&
                                        <img width="20px" src={unitedkingdom}/>
                                    }
                                    {this.state.Language == 'de' &&
                                        <img width="20px" src={germany}/>
                                    }
                                    {this.state.Language == 'fr' &&
                                        <img width="20px" src={france}/>
                                    }
                                    {this.state.Language == 'ko' &&
                                        <img width="20px" src={korea}/>
                                    }
                                    {this.state.Language == 'ch' &&
                                        <img width="20px" src={china}/>
                                    }
                                    {this.state.Language == 'ru' &&
                                        <img width="20px" src={russia}/>
                                    }
                                    {this.state.Language == 'it' &&
                                        <img width="20px" src={italy}/>
                                    }
                                    {this.state.Language == 'jap' &&
                                        <img width="20px" src={japan}/>
                                    }
                                    {this.state.Language == 'port' &&
                                        <img width="20px" src={portugal}/>
                                    }
                                    {this.state.Language == 'turk' &&
                                        <img width="20px" src={turkey}/>
                                    }
                                    {this.state.Language == 'viet' &&
                                        <img width="20px" src={vietnam}/>
                                    }
                                    {this.state.Language == 'spa' &&
                                        <img width="20px" src={spain}/>
                                    }
                                    {this.state.Language == 'arab' &&
                                        <img width="20px" src={oae}/>
                                    }
                                    <img className="ml5px" width="15px" src={downward}/>
                                </a>
                            </summary>
                            <ul>
                                {this.state.Language != 'en' &&
                                <li><img width="24px" onClick={event => this.changeLanguage(event, 'en')} style={{ cursor: 'pointer' }} src={unitedkingdom}/></li>}
                                {this.state.Language != 'de' &&
                                <li><img width="24px" onClick={event => this.changeLanguage(event, 'de')} style={{ cursor: 'pointer' }} src={germany}/></li>}
                                {this.state.Language != 'fr' &&
                                <li><img width="24px" onClick={event => this.changeLanguage(event, 'fr')} style={{ cursor: 'pointer' }} src={france}/></li>}
                                {this.state.Language != 'ko' &&
                                <li><img width="24px" onClick={event => this.changeLanguage(event, 'ko')} style={{ cursor: 'pointer' }} src={korea}/></li>}
                                {this.state.Language != 'ch' &&
                                <li><img width="24px" onClick={event => this.changeLanguage(event, 'ch')} style={{ cursor: 'pointer' }} src={china}/></li>}
                                {this.state.Language != 'ru' &&
                                <li><img width="24px" onClick={event => this.changeLanguage(event, 'ru')} style={{ cursor: 'pointer' }} src={russia}/></li>}
                                {this.state.Language != 'it' &&
                                <li><img width="24px" onClick={event => this.changeLanguage(event, 'it')} style={{ cursor: 'pointer' }} src={italy}/></li>}
                                {this.state.Language != 'jap' &&
                                <li><img width="24px" onClick={event => this.changeLanguage(event, 'jap')} style={{ cursor: 'pointer' }} src={japan}/></li>}
                                {this.state.Language != 'port' &&
                                <li><img width="24px" onClick={event => this.changeLanguage(event, 'port')} style={{ cursor: 'pointer' }} src={portugal}/></li>}
                                {this.state.Language != 'turk' &&
                                <li><img width="24px" onClick={event => this.changeLanguage(event, 'turk')} style={{ cursor: 'pointer' }} src={turkey}/></li>}
                                {this.state.Language != 'viet' &&
                                <li><img width="24px" onClick={event => this.changeLanguage(event, 'viet')} style={{ cursor: 'pointer' }} src={vietnam}/></li>}
                                {this.state.Language != 'spa' &&
                                <li><img width="24px" onClick={event => this.changeLanguage(event, 'spa')} style={{ cursor: 'pointer' }} src={spain}/></li>}
                                {this.state.Language != 'arab' &&
                                <li><img width="24px" onClick={event => this.changeLanguage(event, 'arab')} style={{ cursor: 'pointer' }} src={oae}/></li>}
                            </ul>
                        </details>
                    </div>
                    <div className="HeaderAllMainInfoOut">
                    <div className="HeaderAllMainInfo">
                        <div className="HeaderAllMainInfoImg">
                            <img src={CreditLogo} width="150px"/>
                        </div>
                        <Query query={GET_USER_KYC} variables={{ email: this.state.email }}>
                            {({ data, loading, error}) => {
                                if (loading) return <div>loading</div>;
                                if (error) return <div>error</div>;
                                return (
                                    <>
                                        <StatusKYC UserKYC={data.getUserKYC} ChangeMenu={this.ChangeMenu}/>
                                    </>
                                );
                            }}
                        </Query>
                        <div className="HeaderAllMainInfoTitle">{AuthTraderName}</div>
                        {/*<div className="ClientStatus">{this.props.session.StatusMain}</div>
                        <div className="HeaderAllMainInfoRole">Guest</div>
                        <NavLink to='/investortrader' className="HeaderAllMainInfoButtonStatus"
                                  activeClassName="HeaderAllMainInfoButtonStatusActive" onClick={this.ChangeMenu}>
                            <div className="HeaderAllMainInfoButtonStatusIn">{this.props.session.StatusMain}</div>
                        </NavLink>
                        */}
                    </div>
                    </div>
                    <div className="HeaderAllMainMenuOut">
                    <div className="HeaderAllMainMenu">
                        <a href='https://artyfact.game/?login=true'><div className="HeaderAllMainMenuElement">
                            <div className="HeaderAllMainMenuElementImg HeaderAllMainMenuElementImg01"/>
                            <div className="HeaderAllMainMenuElementText starzone">{menuText.website[this.state.Language]}</div>
                        </div></a>
                        <NavLink to='/' exact  activeClassName="HeaderAllMainMenuActiveLink"  onClick={this.ChangeMenu} ><div className="HeaderAllMainMenuElement">
                            <div className="HeaderAllMainMenuElementImg HeaderAllMainMenuElementImg02"/>
                            <div className="HeaderAllMainMenuElementText starzone">{menuText.dashboard[this.state.Language]}</div>
                        </div></NavLink>
                        <NavLink to='/personal' activeClassName="HeaderAllMainMenuActiveLink"  onClick={this.ChangeMenu} ><div className="HeaderAllMainMenuElement">
                            <div className="HeaderAllMainMenuElementImg HeaderAllMainMenuElementImg03"/>
                            <div className="HeaderAllMainMenuElementText starzone">{menuText.profile[this.state.Language]}</div>
                        </div></NavLink>

                        <NavLink isActive={(_, location) => location.pathname == '/referal' || location.pathname == '/referalstatistic' || location.pathname == '/myguest'} to='/referalstatistic' activeClassName="HeaderAllMainMenuActiveLink"  onClick={this.ChangeMenu} ><div className="HeaderAllMainMenuElement">
                            <div className="HeaderAllMainMenuElementImg HeaderAllMainMenuElementImg04"/>
                            <div className="HeaderAllMainMenuElementText starzone">{menuText.referral[this.state.Language]}</div>
                        </div></NavLink>
                        
                        <NavLink isActive={(_, location) => location.pathname == '/withdrawal'} to='/withdrawal' activeClassName="HeaderAllMainMenuActiveLink"  onClick={this.ChangeMenu} ><div className="HeaderAllMainMenuElement">
                            <div className="HeaderAllMainMenuElementImg HeaderAllMainMenuElementImg05"/>
                            <div className="HeaderAllMainMenuElementText starzone">{menuText.payments[this.state.Language]}</div>
                        </div></NavLink>
                        <NavLink isActive={(_, location) => location.pathname == '/staking'} to='/staking' activeClassName="HeaderAllMainMenuActiveLink"  onClick={this.ChangeMenu} ><div className="HeaderAllMainMenuElement">
                            <div className="HeaderAllMainMenuElementImg HeaderAllMainMenuElementImg06"/>
                            <div className="HeaderAllMainMenuElementText starzone">{menuText.staking[this.state.Language]}</div>
                        </div></NavLink>
                        {/* <NavLink isActive={(_, location) => location.pathname == '/news' || location.pathname.includes('/new/')} to='/news' activeClassName="HeaderAllMainMenuActiveLink" onClick={this.ChangeMenu}><div className="HeaderAllMainMenuElement">
                            <div className="HeaderAllMainMenuElementImg HeaderAllMainMenuElementImgNEWS"/>
                            <div className="HeaderAllMainMenuElementText">{menuText.news[this.state.Language]}</div>
                        </div></NavLink> */}
                        <div className="HeaderAllMainMenuElement" onClick={this.OpenModalFAQ} style={{ cursor: 'pointer' }}>
                            <div className="HeaderAllMainMenuElementImg HeaderAllMainMenuElementImgFAQ"/>
                            <div className="HeaderAllMainMenuElementText starzone">{menuText.faq[this.state.Language]}</div>
                        </div>
                        <div className="HeaderAllMainMenuElement" onClick={this.OpenModalSupport} style={{ cursor: 'pointer' }}>
                            <div className="HeaderAllMainMenuElementImg HeaderAllMainMenuElementImgQ"/>
                            <div className="HeaderAllMainMenuElementText starzone">{menuText.support[this.state.Language]}</div>
                        </div>

                    </div>
                    </div>
                    <SignOut history={history} email={LogoutName} active={ActiveLogout} logout={menuText.logout[this.state.Language]}/>
                </div>
            </div>

            <div className="Modal" style={{ display: this.state.ModalFAQShow ? 'block' : 'none' }}>
                <div class="Modal-dialog" style={{ 'max-width': '800px' }}>
                    <div className="Modal-content">
                        <div className="Modal-header">
                            <div className="closeModal" style={{ right: '-8px' }} onClick={this.CloseModalFAQ}>×</div>
                            {menuText.faq_title[this.state.Language]}
                        </div>
                        <div className="Modal-body">
                            <div dangerouslySetInnerHTML={ {__html: '<iframe src="https://artyfact.game/faq.html" width="100%" style="min-height: 80vh; border: none;"></iframe>'} } />                                            
                        </div>
                    </div>
                </div>
            </div>

            <div className="Modal" style={{ display: this.state.ModalSupportShow ? 'block' : 'none' }}>
                <div class="Modal-dialog" style={{ 'max-width': '520px' }}>
                    <div className="Modal-content">
                        <div className="Modal-header">
                            <div className="closeModal" style={{ right: '-8px' }} onClick={this.CloseModalSupport}>×</div>
                            {menuText.support_center[this.state.Language]}
                        </div>
                        <div className="Modal-body">
                            <div dangerouslySetInnerHTML={ {__html: '<iframe src="https://artyfact.game/mail/phMailer.php" width="100%" height="480px" style="border: none;"></iframe>'} } />                                            
                        </div>
                    </div>
                </div>
            </div>
            
            </>
        )
    }
    }}

export default withAuth(session => session && session.getCurrentUser)(withRouter(HeaderAll));